import { render, staticRenderFns } from "./add-image.vue?vue&type=template&id=4f0efbc0&scoped=true&"
import script from "./add-image.vue?vue&type=script&lang=js&"
export * from "./add-image.vue?vue&type=script&lang=js&"
import style0 from "./add-image.vue?vue&type=style&index=0&id=4f0efbc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0efbc0",
  null
  
)

export default component.exports